"use client";

import React from "react";
import styles from "@components/molecules/ReviewExportCard/style.module.scss";
import Button from "@components/atoms/Button/index";
import Image from "@components/atoms/Image/index";
import { ReviewExportCardProps } from "@components/molecules/ReviewExportCard/ReviewExportCard.types";
import assetLoader from "@utils/internalImageLoder";

const Index: React.FC<ReviewExportCardProps> = ({
  imageSrc,
  title,
  url,
  publishedDate,
  content,
}) => {
  return (
    <div className={styles["card_component"]}>
      <div className={styles["image_card"]}>
        <div className={styles["image_wrapper"]}>
          <Image
            loading={"lazy"}
            width={500}
            height={400}
            src={imageSrc}
            alt={title}
            className={styles.image_bar}
          />
        </div>
      </div>
      <div className={styles["content_area"]}>
        <h2 className={styles["title"]}>{title}</h2>
        <p className={styles["date_time"]}>{`Published on ${publishedDate}`}</p>
        <p className={styles["description"]}>{content}</p>

        <Button
          onButtonClick={() => {
            if (url) {
              window.open(url, "_blank", "noopener,noreferrer");
            }
          }}
          variant="review_export_button"
        >
          <span className={styles.icon}>
            <Image
              loading={"lazy"}
              className={styles.image_exclusive_badge}
              width={500}
              height={400}
              src={`${assetLoader()}/exclusive-badge.png`}
              alt={"exclusive-badge"}
            />
          </span>
          Read the complete review
        </Button>
      </div>
    </div>
  );
};

export default Index;
